import * as React from 'react';

export function isSafeMode(form: any) {
  // Backward compatible: either boolean or explicit 'safe'
  return form?.useLowRiskMode === true || form?.scriptMode === 'safe';
}

export const SafeModeGate: React.FC<{ form: any; children: React.ReactNode }> = ({ form, children }) =>
  isSafeMode(form) ? <>{children}</> : null;